import { create } from 'zustand';
import apiClient from '../api/api';
import { API_ENDPOINTS } from '../endpoints';
import withRetry from '../utils/withRetry';

const useAnalysisStore = create((set) => ({
  questionnaires: [],
  analysisDetail: [],
  loading: false,
  detailLoading: false,
  error: null,
  detailError: null,
  showHint: false,
  showAnswers: false,
  topN: 3,
  openQrModal: false,
  selectedQrCodeData: { qrCode: '', name: '' },
  zoomImage: null,

  fetchAdminQuestionnaires: async () => {
    try {
      set({ loading: true, error: null });
      const response = await withRetry(() => apiClient.get(API_ENDPOINTS.getAdminQuestionnaire));
      set({ questionnaires: response.data || [], loading: false });
    } catch (err) {
      console.error('Failed to fetch admin questionnaires', err);
      set({ loading: false, error: 'Failed to load questionnaires.' });
    }
  },

  fetchQuestionnaireAnalysis: async (id) => {
    if (!id) return;
    try {
      set({ detailLoading: true, detailError: null });
      const response = await withRetry(() => apiClient.get(API_ENDPOINTS.getQuestionnaireAnalysis(id)));
      set({ analysisDetail: response.data || [], detailLoading: false });
    } catch (err) {
      console.error('Failed to fetch questionnaire analysis', err);
      set({ detailLoading: false, detailError: 'Failed to load analysis.' });
    }
  },
  setShowHint: (value) => set({ showHint: value }),
  setShowAnswers: (value) => set({ showAnswers: value }),
  setTopN: (value) => set({ topN: value }),
  clearAnalysisDetail: () => set({ analysisDetail: [], showHint: false, showAnswers: false, zoomImage: null, topN: 3 }),
  setOpenQrModal: (value) => set({ openQrModal: value }),
  setSelectedQrCodeData: (qrCode, name) => set({ selectedQrCodeData: { qrCode, name } }),
  setZoomImage: (url) => set({ zoomImage: url }),
}));

export default useAnalysisStore;
